import { cn } from '@agro1desenvolvimento/agro1-design-system/lib';

type IconProperties = {
  className?: string;
};

const MASK_ICON_CLASSES =
  'inline-block bg-current [mask-position:center] [mask-repeat:no-repeat] [mask-size:contain]';

function MaskIcon({ className }: IconProperties) {
  return <span aria-hidden="true" className={cn(MASK_ICON_CLASSES, className)} />;
}

type ImageIconProperties = IconProperties & {
  src: string;
};

function ImageIcon({ src, className }: ImageIconProperties) {
  return <img alt="" aria-hidden="true" className={cn('inline-block', className)} src={src} />;
}

export function HomeIcon({ className }: IconProperties) {
  return (
    <MaskIcon className={cn('size-4.5 [mask-image:url(/assets/icons/home.svg)]', className)} />
  );
}

export function CollapseMenuIcon({ className }: IconProperties) {
  return (
    <MaskIcon
      className={cn('size-4.5 [mask-image:url(/assets/icons/collapse-menu.svg)]', className)}
    />
  );
}

export function ExpandMenuIcon({ className }: IconProperties) {
  return (
    <MaskIcon
      className={cn('size-4.5 [mask-image:url(/assets/icons/expand-menu.svg)]', className)}
    />
  );
}

export function SeedLabIcon({ className }: IconProperties) {
  return (
    <MaskIcon
      className={cn('h-4.75 w-4 [mask-image:url(/assets/icons/seed-lab.svg)]', className)}
    />
  );
}

export function SyncIcon({ className }: IconProperties) {
  return <MaskIcon className={cn('size-4 [mask-image:url(/assets/icons/sync.svg)]', className)} />;
}

export function ResetFiltersIcon({ className }: IconProperties) {
  return (
    <MaskIcon
      className={cn('size-4.5 [mask-image:url(/assets/icons/reset-filters.svg)]', className)}
    />
  );
}

export function RowArrowIcon({ className }: IconProperties) {
  return (
    <MaskIcon
      className={cn('h-2 w-4.5 [mask-image:url(/assets/icons/row-arrow.svg)]', className)}
    />
  );
}

export function RowEyeIcon({ className }: IconProperties) {
  return (
    <MaskIcon className={cn('size-4 [mask-image:url(/assets/icons/row-eye.svg)]', className)} />
  );
}

export function PeriodIcon({ className }: IconProperties) {
  return (
    <MaskIcon className={cn('size-4 [mask-image:url(/assets/icons/period.svg)]', className)} />
  );
}

export function CaretUpIcon({ className }: IconProperties) {
  return (
    <MaskIcon className={cn('h-2 w-3.5 [mask-image:url(/assets/icons/caret-up.svg)]', className)} />
  );
}

export function CameraIcon({ className }: IconProperties) {
  return (
    <MaskIcon className={cn('size-4 [mask-image:url(/assets/icons/camera.svg)]', className)} />
  );
}

export function UploadIcon({ className }: IconProperties) {
  return (
    <MaskIcon className={cn('size-4 [mask-image:url(/assets/icons/upload.svg)]', className)} />
  );
}

export function PhotoPlaceholderIcon({ className }: IconProperties) {
  return (
    <MaskIcon
      className={cn('size-4.5 [mask-image:url(/assets/icons/photo-placeholder.svg)]', className)}
    />
  );
}

export function PhotoRemoveIcon({ className }: IconProperties) {
  return (
    <MaskIcon
      className={cn('size-2 [mask-image:url(/assets/icons/photo-remove.svg)]', className)}
    />
  );
}

export function EntryRemoveIcon({ className }: IconProperties) {
  return (
    <MaskIcon
      className={cn('size-4.5 [mask-image:url(/assets/icons/entry-remove.svg)]', className)}
    />
  );
}

export function RepetitionRejectedIcon({ className }: IconProperties) {
  return (
    <ImageIcon className={cn('size-3.75', className)} src="/assets/icons/repetition-rejected.svg" />
  );
}

export function RepetitionDoneIcon({ className }: IconProperties) {
  return (
    <ImageIcon className={cn('size-3.75', className)} src="/assets/icons/repetition-done.svg" />
  );
}

export function RepetitionPendingIcon({ className }: IconProperties) {
  return (
    <ImageIcon className={cn('size-3.75', className)} src="/assets/icons/repetition-pending.svg" />
  );
}

export function ForwardArrowIcon({ className }: IconProperties) {
  return (
    <MaskIcon
      className={cn('size-5 [mask-image:url(/assets/icons/forward-arrow.svg)]', className)}
    />
  );
}

export function BreadcrumbArrowIcon({ className }: IconProperties) {
  return (
    <MaskIcon
      className={cn('size-4.5 [mask-image:url(/assets/icons/breadcrumb-arrow.svg)]', className)}
    />
  );
}

export function MarkAllIcon({ className }: IconProperties) {
  return (
    <MaskIcon className={cn('size-3.5 [mask-image:url(/assets/icons/mark-all.svg)]', className)} />
  );
}

export function UnmarkAllIcon({ className }: IconProperties) {
  return (
    <MaskIcon
      className={cn('size-3.5 [mask-image:url(/assets/icons/unmark-all.svg)]', className)}
    />
  );
}

export function InstallCheckIcon({ className }: IconProperties) {
  return (
    <MaskIcon
      className={cn('h-2.75 w-3.75 [mask-image:url(/assets/icons/install-check.svg)]', className)}
    />
  );
}

export function CloseIcon({ className }: IconProperties) {
  return (
    <MaskIcon className={cn('size-4.5 [mask-image:url(/assets/icons/close.svg)]', className)} />
  );
}

export function WarningIcon({ className }: IconProperties) {
  return (
    <MaskIcon className={cn('size-6.5 [mask-image:url(/assets/icons/warning.svg)]', className)} />
  );
}

export function ClockIcon({ className }: IconProperties) {
  return <MaskIcon className={cn('size-4 [mask-image:url(/assets/icons/clock.svg)]', className)} />;
}

export function AlertCircleIcon({ className }: IconProperties) {
  return (
    <MaskIcon
      className={cn('size-4 [mask-image:url(/assets/icons/alert-circle.svg)]', className)}
    />
  );
}

export function TrashIcon({ className }: IconProperties) {
  return <MaskIcon className={cn('size-4 [mask-image:url(/assets/icons/trash.svg)]', className)} />;
}

export function SproutIcon({ className }: IconProperties) {
  return (
    <MaskIcon className={cn('size-4.5 [mask-image:url(/assets/icons/sprout.svg)]', className)} />
  );
}

export function PlusIcon({ className }: IconProperties) {
  return (
    <MaskIcon className={cn('size-3.5 [mask-image:url(/assets/icons/plus.svg)]', className)} />
  );
}

export function PencilIcon({ className }: IconProperties) {
  return (
    <MaskIcon className={cn('size-3.5 [mask-image:url(/assets/icons/pencil.svg)]', className)} />
  );
}

export function InfoIcon({ className }: IconProperties) {
  return (
    <MaskIcon className={cn('size-3.5 [mask-image:url(/assets/icons/info.svg)]', className)} />
  );
}

export function TableIcon({ className }: IconProperties) {
  return (
    <MaskIcon className={cn('size-3.5 [mask-image:url(/assets/icons/table.svg)]', className)} />
  );
}

export function CheckIcon({ className }: IconProperties) {
  return (
    <MaskIcon className={cn('size-3.5 [mask-image:url(/assets/icons/check.svg)]', className)} />
  );
}

export function DismissIcon({ className }: IconProperties) {
  return (
    <MaskIcon className={cn('size-3.5 [mask-image:url(/assets/icons/dismiss.svg)]', className)} />
  );
}

export function SeedlingListIcon({ className }: IconProperties) {
  return (
    <MaskIcon
      className={cn('size-4 [mask-image:url(/assets/icons/seedling-list.svg)]', className)}
    />
  );
}

export function ChevronUpIcon({ className }: IconProperties) {
  return (
    <MaskIcon className={cn('size-5 [mask-image:url(/assets/icons/chevron-up.svg)]', className)} />
  );
}
